// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"877":"7ec4ea2a","6920":"7ec4ea2a","6923":"7ec4ea2a","7376":"18e29269","8777":"fe58350d"}[chunkId] + ".chunk.css";
};